import FileStoragePanel from './FileStoragePanel';
import {
  DELETE_ACCOUNT_WARNING,
  confirmDeleteAccount,
  DELETE_ACCOUNT_SUCCESS_MESSAGE,
} from '../lib/deleteAccount';
import type { CloudStorageMeta } from '../lib/cloudStorage';
import './FileStoragePanel.css';

interface DeleteAccountBlockProps {
  onDelete: () => Promise<void> | void;
  buttonLabel?: string;
}

export function DeleteAccountBlock({
  onDelete,
  buttonLabel = 'Delete account',
}: DeleteAccountBlockProps) {
  const handleClick = async () => {
    if (!confirmDeleteAccount()) return;
    await onDelete();
  };

  return (
    <div className="file-storage-delete-wrap">
      <p className="file-storage-delete-warning">{DELETE_ACCOUNT_WARNING}</p>
      <button
        type="button"
        className="btn-primary file-storage-delete-btn"
        onClick={() => void handleClick()}
      >
        {buttonLabel}
      </button>
    </div>
  );
}

interface FileStorageModalProps {
  titleId: string;
  storageKey: string;
  onClose: () => void;
  onPersist?: (meta: CloudStorageMeta) => Promise<void> | void;
  onDelete?: () => Promise<void> | void;
  showDelete?: boolean;
}

export function FileStorageModal({
  titleId,
  storageKey,
  onClose,
  onPersist,
  onDelete,
  showDelete = false,
}: FileStorageModalProps) {
  return (
    <div
      className="living-room-doc-upload-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      onClick={onClose}
    >
      <div
        className="living-room-doc-upload-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id={titleId} className="section-header living-room-doc-upload-title">
          File Storage
        </h2>
        <p className="living-room-doc-upload-intro">
          Choose where your business files live. Mentology stores location metadata only.
        </p>
        <FileStoragePanel
          storageKey={storageKey}
          onPersist={onPersist}
          defaultOpen
        />
        {showDelete && onDelete && (
          <DeleteAccountBlock
            onDelete={async () => {
              await onDelete();
              onClose();
            }}
          />
        )}
        <button type="button" className="btn-primary living-room-doc-upload-close" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

export { DELETE_ACCOUNT_SUCCESS_MESSAGE };
